import { EmployeeSummaryDto } from './employee-summary-dto.model';
import { ShiftGroupTypeDto } from './shift-group-type-dto.model';


export class EmployeeShiftDto implements IEmployeeShiftDto {
    id!: number;
    employee!: EmployeeSummaryDto;
    shiftGroupType!: ShiftGroupTypeDto;
    fromDate!: Date;
    toDate!: Date | undefined;

    constructor(data?: IEmployeeShiftDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.employee = _data["employee"] ? EmployeeSummaryDto.fromJS(_data["employee"]) : <any>undefined;
            this.shiftGroupType = _data["shiftGroupType"] ? ShiftGroupTypeDto.fromJS(_data["shiftGroupType"]) : <any>undefined;
            this.fromDate = _data["fromDate"] ? new Date(_data["fromDate"].toString()) : <any>undefined;
            this.toDate = _data["toDate"] ? new Date(_data["toDate"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): EmployeeShiftDto {
        data = typeof data === 'object' ? data : {};
        let result = new EmployeeShiftDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["employee"] = this.employee ? this.employee.toJSON() : <any>undefined;
        data["shiftGroupType"] = this.shiftGroupType ? this.shiftGroupType.toJSON() : <any>undefined;
        data["fromDate"] = this.fromDate ? this.fromDate.toISOString() : <any>undefined;
        data["toDate"] = this.toDate ? this.toDate.toISOString() : <any>undefined;
        return data; 
    }
}

export interface IEmployeeShiftDto {
    id: number;
    employee: EmployeeSummaryDto;
    shiftGroupType: ShiftGroupTypeDto;
    fromDate: Date;
    toDate: Date | undefined;
}

